import type { UserRole } from '@/stores/authStore';

/**
 * De pagina "Mijn feedback" van de rol employee: de bestaande eigenpagina van Werkkwaliteit
 * (`OwnWorkPage`). Als constante, omdat het pad op meerdere plaatsen moet kloppen — de landing, de
 * bewaking in `ProtectedRoute` en het menu — en hernoemen zonder constante de bewaking stil breekt.
 */
export const MIJN_FEEDBACK_PAD = '/werkkwaliteit';

/**
 * Waar iemand na het inloggen (en na de eerste wachtwoordwijziging) landt.
 *
 * CAP-6 van spec-mijn-feedback-weekrapport: een employee landt op Mijn feedback en ziet verder
 * niets van het portaal. Klant, leidinggevende en beheerder landen waar ze al landden. Een
 * ontbrekende of onbekende rol valt terug op het dashboard van een klant: het scherm met de minste
 * rechten, nooit een intern.
 */
export function landingPath(role: UserRole | null | undefined): string {
  if (role === 'employee') return MIJN_FEEDBACK_PAD;
  if (role === 'manager' || role === 'admin') return '/clients';
  return '/dashboard';
}
